module.exports = __webpack_public_path__ + "Trophy-29aNPFO.svg";